import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";

const ICONOS_TIPO_BIEN = {
  INMUEBLE: <MapsHomeWorkIcon sx={{ mr: 1, color: "primary.main" }} />,
  MUEBLE: <DirectionsCarIcon sx={{ mr: 1, color: "primary.main" }} />,
};

function CardBienes({ proceso, bienes }) {
  console.log("Proceso:", proceso.id);

  // Dividir bienes en dos listas separadas
  const bienesInmuebles = bienes.filter((bien) => bien.tipo_bien === "INMUEBLE");
  const bienesMuebles = bienes.filter((bien) => bien.tipo_bien === "MUEBLE");

  return (
    <Card sx={{ width: "100%", padding: 2 }}>
      <SuiBox display="flex" flexDirection="column" gap={2}>
        {/* Tabla para INMUEBLES */}
        {bienesInmuebles.length > 0 && (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <SuiBox display="flex" alignItems="center" mb={1}>
              {ICONOS_TIPO_BIEN["INMUEBLE"]}
              <SuiTypography variant="h6" fontWeight="bold" color="primary">
                INMUEBLES
              </SuiTypography>
            </SuiBox>
            <Divider sx={{ my: 1 }} />
            <TableContainer component={Paper}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Tipo</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Dirección</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>
                    Matrícula Inmobiliaria
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>
                    Afectaciones
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>
                    Avalúo Catastral
                  </TableCell>
                </TableRow>
                <TableBody>
                  {bienesInmuebles.map((bien) => (
                    <TableRow key={bien.id}>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.tipo_inmueble}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.direccion}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {bien.matricula_inmobiliaria}
                      </TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {bien.afectaciones || "N/A"}
                      </TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        $ {Number(bien.avaluo_catastral || 0).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
        <Divider sx={{ my: 1.25 }} />

        {/* Tabla para MUEBLES */}
        {bienesMuebles.length > 0 && (
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <SuiBox display="flex" alignItems="center" mb={1}>
              {ICONOS_TIPO_BIEN["MUEBLE"]}
              <SuiTypography variant="h6" fontWeight="bold" color="primary">
                MUEBLES
              </SuiTypography>
            </SuiBox>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Tipo</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Placa</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Color</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Modelo</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>Marca</TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>
                    Afectaciones
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", padding: "4px 8px" }}>
                    Avalúo Catastral
                  </TableCell>
                </TableRow>
                <TableBody>
                  {bienesMuebles.map((bien) => (
                    <TableRow key={bien.id}>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.tipo_mueble}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.placa || "N/A"}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.color || "N/A"}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.modelo || "N/A"}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>{bien.marca || "N/A"}</TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        {bien.afectaciones || "N/A"}
                      </TableCell>
                      <TableCell sx={{ padding: "4px 8px" }}>
                        $ {Number(bien.avaluo_catastral || 0).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}

        {/* Mensaje si no hay bienes */}
        {bienesInmuebles.length === 0 && bienesMuebles.length === 0 && (
          <Typography variant="body1" color="textSecondary">
            No hay bienes registrados para este proceso.
          </Typography>
        )}
      </SuiBox>
    </Card>
  );
}

CardBienes.propTypes = {
  proceso: PropTypes.object.isRequired,
  bienes: PropTypes.array.isRequired,
};

export default CardBienes;
